function Faq(props: { items: { question: string, answer: string }[]}) {

  return (<>
    <div className="accordion" id="faqAccordion">
      {props.items.map((item, index) => 
        <div className="accordion-item">
          <h2 className="accordion-header" id={`faqAccordionHeading${index}`}>
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#faqAccordionCollapse${index}`} aria-expanded="false" aria-controls={`faqAccordionCollapse${index}`}>
              {item.question}
            </button>
          </h2>
          <div id={`faqAccordionCollapse${index}`} className="accordion-collapse collapse" aria-labelledby={`faqAccordionHeading${index}`} data-bs-parent="#faqAccordion">
            <div className="accordion-body">
              {item.answer}
            </div>
          </div>
        </div>
      )}
    </div>
    <script type="application/ld+json">{`
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [${props.items.map((item, index) =>
        `
        {
          "@type": "Question",
          "name": "${item.question}",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "${item.answer}"
          }
        }`)}
      ]
    }`} 
    </script>
  </>);
}

export default Faq;
